import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { Division } from '../../models/divisions/division';

@Injectable()
export class DivisionService {

    public divisions: Division[];
    public divisionsObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.divisions = [];
        this.divisionsObject = {};
    }

    public getAll(): Observable<Division[]> {
        if (!!this.divisions && this.divisions.length > 0) {
            return Observable.create((observer: Subscriber<Division[]>) => {
                observer.next(this.divisions);
                observer.complete();
            });
        }
        const url = 'divisions/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.divisions = r.Result;
                this.divisionsObject = this.divisions.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return this.divisions;
        }).catch(this.handleError);
    }

    public getAllBySchoolYearId(schoolYearId): Observable<Division[]> {
        const url = 'divisions/allBySchoolYearId/' +  schoolYearId;
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.divisions = r.Result;
                this.divisionsObject = this.divisions.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return this.divisions;
        }).catch(this.handleError);
    }

    public getAllByShiftId(currentShiftId, schoolYearId): Observable<Division[]> {
        /*if (!!this.divisions && this.divisions.length > 0) {
            return Observable.create((observer: Subscriber<Division[]>) => {
                observer.next(this.divisions);
                observer.complete();
            });
        }*/
        const url = 'divisions/allbyshiftid/' + currentShiftId + '/' + schoolYearId;
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.divisions = r.Result;
                this.divisionsObject = this.divisions.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return this.divisions;
        }).catch(this.handleError);
    }

    public getAllByShiftIdForce(currentShiftId, schoolYearId): Observable<Division[]> {
        const url = 'divisions/allbyshiftid/' + currentShiftId + '/' + schoolYearId;

        console.log(url);
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.divisions = r.Result;
                this.divisionsObject = this.divisions.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return this.divisions;
        }).catch(this.handleError);
    }

    public getAllCountStudents(schoolYearId, userId): Observable<Division[]> {
        // if (!!this.divisions && this.divisions.length > 0) {
        //     return Observable.create((observer: Subscriber<Division[]>) => {
        //         observer.next(this.divisions);
        //         observer.complete();
        //     });
        // }
        const url = 'divisions/AllCountStudentsByUser/' + schoolYearId + "/" + userId;
        return this.http.get(url).map(response => {
            let result = [];
            let r = response.json();
            if (r.ResultCode === 1) {
                result = r.Result;
                // this.divisions = r.Result;
                // this.divisionsObject = this.divisions.reduce((result, st) => {
                //     result[String(st.Id)] = result[String(st.Id)] || {};
                //     result[String(st.Id)] = st;
                //     return result;
                // }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            // return this.divisions;
            return result;
        }).catch(this.handleError);
    }

    public getAllWithShiftId(currentShiftId, schoolYearId): Observable<any> {
        // if (!!this.divisions && this.divisions.length > 0) {
        //     return Observable.create((observer: Subscriber<Division[]>) => {
        //         observer.next(this.divisions);
        //         observer.complete();
        //     });
        // }
        const url = 'divisions/allcountstudents/' + currentShiftId + '/' + schoolYearId;
        return this.http.get(url).map(response => {
            let result = [];
            let r = response.json();
            if (r.ResultCode === 1) {
                result = r.Result;
                // this.divisions = r.Result;
                // this.divisionsObject = this.divisions.reduce((result, st) => {
                //     result[String(st.Id)] = result[String(st.Id)] || {};
                //     result[String(st.Id)] = st;
                //     return result;
                // }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            // return this.divisions;
            return {
                divisions: result,
                shiftId: currentShiftId
            };
        }).catch(this.handleError);
    }

    public getById(id: number): Observable<any> {
        // if (!!this.storeTypes && this.storeTypes.length > 0 && !!this.storeTypes.find(st => st.id == id)) {
        //     return Observable.create((observer: Subscriber<StoreType>) => {
        //         observer.next(this.storeTypes.find(st => st.id == id));
        //         observer.complete();
        //     });
        // }
        const url = 'divisions/' + id;
        return this.http.get(url).map(response => {
            const r = response.json();
            let division = null;
            if (r.ResultCode === 1) {
                division = r.Result;
                // let alreadyExist = this.storeTypes.find(st => st.id == storeType.id);
                // if (!alreadyExist) {
                //     this.storeTypes.push(storeType);
                //     this.storeTypesObject[storeType.id] = storeType;
                // }
            } else {
                console.error('StoreTypeService > getById > response', r);
            }
            return division;
        }).catch(this.handleError);
    }

    /*
    public add(name: string, description: string) {
        const url = 'store-types/add';
        return this.http.post(url, {
            Name: name,
            Description: description
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public edit(id: number, name: string, description: string) {
        const url = 'store-types/edit';
        return this.http.put(url, {
            Id: id,
            Name: name,
            Description: description
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: number) {
        const url: string = 'store-types/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }*/

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public getPaymentSummary(schoolYearId, paymentDate): Observable<Division[]> {
        const url = 'divisions/payments/' + schoolYearId + '/' + paymentDate;
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.divisions = r.Result;
                this.divisionsObject = this.divisions.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getPaymentSummary > response', r);
            }
            return this.divisions;
        }).catch(this.handleError);
    }



    saveColorConfig(data: any[]) {
        const url = 'divisions/saveColorConfig';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/divisions/division.service.ts